import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
type Notification = {
  name: string;
  location: string;
  time: string;
  initials: string;
};
const notifications: Notification[] = [{
  name: 'Sarah Jenkins',
  location: 'New York, USA',
  time: '5 minutes ago',
  initials: 'SJ'
}, {
  name: 'David Smith',
  location: 'London, UK',
  time: '12 minutes ago',
  initials: 'DS'
}, {
  name: 'Emily Chen',
  location: 'Toronto, Canada',
  time: '18 minutes ago',
  initials: 'EC'
}, {
  name: 'Michael Brown',
  location: 'Sydney, Australia',
  time: '27 minutes ago',
  initials: 'MB'
}, {
  name: 'Jessica Walsh',
  location: 'Dublin, Ireland',
  time: '41 minutes ago',
  initials: 'JW'
}];
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const showTimer = window.setTimeout(() => setVisible(true), 4500);
    return () => window.clearTimeout(showTimer);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    const nextTimer = window.setTimeout(() => {
      setVisible(false);
      window.setTimeout(() => {
        if (!dismissed) {
          setIndex(current => (current + 1) % notifications.length);
          setVisible(true);
        }
      }, 700);
    }, 5000);
    return () => window.clearTimeout(nextTimer);
  }, [visible, dismissed]);
  if (dismissed) return null;
  const notification = notifications[index];
  return <div className="pointer-events-none fixed bottom-4 left-1/2 z-50 flex w-full -translate-x-1/2 justify-center px-4" data-id="element-219" data-mp="yjochidvt4fp">
      <AnimatePresence mode="wait" data-id="element-220" data-mp="3nca4v7p9pw5h">
        {visible && <motion.div key={notification.name} initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 10
      }} transition={{
        duration: 0.25
      }} className="pointer-events-auto relative flex w-full max-w-sm items-center gap-3 rounded-2xl border border-ballet-line bg-white p-3.5 shadow-soft" data-id="element-221" data-mp="3j9n7kr9tvj0w">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-ballet-blush text-sm font-bold text-ballet-rose" data-id="element-222" data-mp="31zjd3wztaqrz">
              {notification.initials}
            </span>
            <div className="min-w-0 flex-1" data-id="element-223" data-mp="2s3gdoywch68q">
              <p className="text-xs text-ballet-muted" data-id="element-224" data-mp="2x1841ohcckat">
                {notification.location}
              </p>
              <p className="mt-0.5 text-sm leading-5 text-ballet-ink" data-id="element-225" data-mp="2j0xa2ckqiplf">
                <strong data-id="element-226" data-mp="2j3t9k5c8dmbz">{notification.name}</strong> purchased Ballet Teacher
                Ready™
              </p>
              <p className="mt-1 flex items-center gap-1 text-[11px] font-medium text-ballet-green" data-id="element-227" data-mp="24egp07297psc">
                <ShoppingBagIcon size={11} data-id="element-228" data-mp="1zfx3g7rkog0i" /> Verified purchase ·{' '}
                {notification.time}
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss purchase notification" className="self-start text-ballet-muted hover:text-ballet-ink" data-id="element-229" data-mp="2dg7tj8l25qkm">
              <XIcon size={15} data-id="element-230" data-mp="2iej5bouwyb5h" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}